import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface SearchResult {
  type: 'product' | 'salesOrder' | 'businessPartner' | 'contact' | 'salesOrderCustomer' | 'invoice' | 'shipment';
  id: string;
  title: string;
  imageUrl?: string;
  data: any;
}

export interface SearchResponse {
  product: any[];
  salesOrder: any[];
  businessPartner: any[];
  contact: any[];
  salesOrderCustomer: any[];
  invoice: any[];
  shipment: any[];
}

@Injectable({
  providedIn: 'root'
})
export class UnifiedSearchService {
  private host = environment.apiUrlHost;

  constructor(private http: HttpClient) { }

  /**
   * Perform unified search across all data types
   * @param query Search query string
   * @param role User role (admin/customer)
   * @param limit Maximum number of results to return
   * @returns Observable with search results
   */
  search(query: string): Observable<SearchResponse> {
    const params = new HttpParams()
      .set('query', query);

    return this.http.get<SearchResponse>(`${this.host}/unified-search/`, { params });
  }

  /**
   * Get search suggestions (for autocomplete)
   * @param query Partial search query
   * @param role User role
   * @param limit Maximum suggestions
   */
  getSuggestions(query: string, role: string, limit: number = 10): Observable<SearchResponse> {
    const params = new HttpParams()
      .set('query', query);

    return this.http.get<SearchResponse>(`${this.host}/unified-search/`, { params });
  }
}
